import type { ColumnDef } from '@tanstack/react-table';

import { CellCheck } from '../typography';

export function selectBoxColDef<T>() {
  const columns: ColumnDef<T>[] = [
    {
      id: 'select',
      meta: { name: 'Select', className: 'w-10 max-w-10 pl-3' },
      header: ({ table }) => (
        <div className="pl-1">
          <CellCheck
            isChecked={table.getIsAllPageRowsSelected()}
            label="Select all"
            check={table.toggleAllPageRowsSelected}
          />
        </div>
      ),
      cell: ({ row }) => <CellCheck isChecked={row.getIsSelected()} label="Select all" check={row.toggleSelected} />,
      enableSorting: false,
      enableHiding: false,
    },
  ];

  return columns;
}
